var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.012,
    height: 42.515,
    viewBox: "0 0 34.012 42.515",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_2_",
    "data-name": "user (2)",
    transform: "translate(-0.479 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M14.629,14A10.629,10.629,0,0,0,4,24.629a6.377,6.377,0,0,0,6.377,6.377H31.635a6.377,6.377,0,0,0,6.377-6.377A10.629,10.629,0,0,0,27.383,14Z",
    transform: "translate(-3.521 13.509)",
    fill: "#df9426",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M17.629,2A10.629,10.629,0,1,0,28.257,12.629,10.629,10.629,0,0,0,17.629,2Z",
    transform: "translate(-0.329 0)",
    fill: "#df9426",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.6bb9f071b0171d0f6dad1b8a03b37bee.svg";
export { ForwardRef as ReactComponent };